export const environment = {
  production: true,
  apiUrl: 'https://devcounting.trakrsuite.com/api',
  apiAuthUrl: 'https://devcounting.trakrsuite.com/api/auth'
};
